import { render, staticRenderFns } from "./PastDueTodoView.vue?vue&type=template&id=6b03b522"
import script from "./PastDueTodoView.vue?vue&type=script&lang=js"
export * from "./PastDueTodoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports